/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Select_JobInputs */

const en_deep_match_select_job = /** @type {(inputs: Deep_Match_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

const de_deep_match_select_job = /** @type {(inputs: Deep_Match_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

const fr_deep_match_select_job = /** @type {(inputs: Deep_Match_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

const es_deep_match_select_job = /** @type {(inputs: Deep_Match_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

const it_deep_match_select_job = /** @type {(inputs: Deep_Match_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

const nl_deep_match_select_job = /** @type {(inputs: Deep_Match_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

const pl_deep_match_select_job = /** @type {(inputs: Deep_Match_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

const fi_deep_match_select_job = /** @type {(inputs: Deep_Match_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

const da_deep_match_select_job = /** @type {(inputs: Deep_Match_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

const sv_deep_match_select_job = /** @type {(inputs: Deep_Match_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

/**
* | output |
* | --- |
* | "Select a job..." |
*
* @param {Deep_Match_Select_JobInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_select_job = /** @type {((inputs?: Deep_Match_Select_JobInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Select_JobInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_select_job(inputs)
	if (locale === "fr") return fr_deep_match_select_job(inputs)
	if (locale === "es") return es_deep_match_select_job(inputs)
	if (locale === "it") return it_deep_match_select_job(inputs)
	if (locale === "nl") return nl_deep_match_select_job(inputs)
	if (locale === "pl") return pl_deep_match_select_job(inputs)
	if (locale === "fi") return fi_deep_match_select_job(inputs)
	if (locale === "da") return da_deep_match_select_job(inputs)
	if (locale === "sv") return sv_deep_match_select_job(inputs)
	return en_deep_match_select_job(inputs)
});